import * as endpoints from '@App/constants/endpoints';
import interceptor    from '../interceptor';
import { get }        from '../util';
import { post }       from '../util';
import { put }        from '../util';
import { del }        from '../util';

const MEDICALRECORD = 'medicalrecords';
const PREREGISTRATIONLINK = 'pre-registration';

export const addPreCustomerRegistration = async ({header, params}) => {
  const pathUrl = `${endpoints.API_MEDICALRECORD}/${PREREGISTRATIONLINK}`;
  const axios   = interceptor(header);
  return await post(axios, pathUrl, params);
};

export const getPreCustomerRegistration = async ({header, params}) => {
  const pathUrl = `${endpoints.API_MEDICALRECORD}/${PREREGISTRATIONLINK}`;
  const axios   = interceptor(header);
  return await get(axios, pathUrl, params);
};

export const updatePreCustomerRegistration = async ({header, params}) => {
  const pathUrl = `${endpoints.API_MEDICALRECORD}/${PREREGISTRATIONLINK}`;
  const axios   = interceptor(header);
  return await put(axios, pathUrl, params);
};

// Public endpoints for pre-registration flow by link
export const getPreRegistrationByLinkId = async ({ linkId }) => {
  const pathUrl = `${endpoints.API_MEDICALRECORD}/${PREREGISTRATIONLINK}/${linkId}`;
  // no auth cookie; interceptor without auth headers
  const axios   = interceptor({});
  return await get(axios, pathUrl);
};

export const submitPreRegistrationByLinkId = async ({ linkId, params }) => {
  const pathUrl = `${endpoints.API_MEDICALRECORD}/${PREREGISTRATIONLINK}/${linkId}`;
  const axios   = interceptor({});
  return await post(axios, pathUrl, params);
};

export const deletePreCustomerRegistration = async ({header, params}) => {
  const pathUrl = `${endpoints.API_MEDICALRECORD}/${PREREGISTRATIONLINK}`;
  const axios   = interceptor(header);
  return await del(axios, pathUrl, params);
};
